import React, { Component } from "react";
import { Confirm, Form, Message, Segment } from "semantic-ui-react";
import set from "lodash/set";
import request from "../../utils/request";

const resetPrinters = () => {
  return [
    {
      disableconfirmed: "0",
      enabled: "no",
      host: "",
      id: "0",
      port: "",
      printer_status: "0"
    }
  ];
};

class PrinterTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      xhrStatus: "",
      xhrMessage: "",
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: "",
      printers: resetPrinters(),
      locationName: ""
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleRestart = this.handleRestart.bind(this);
  }

  componentDidMount = () => {
    this.setState({
      isMounted: true
    });

    this.fetchData();
  };

  fetchData = () => {
    return request.get(this, "api:/drum-printer", {}).then(resp => {
      let printers = resetPrinters();
      let merge = printers.concat(resp);
      this.setState({ printers: merge, isLoading: false });
    });
  };

  deletePrinter = (e, { printer, name }) => {
    this.setState({
      confirmOpen: true,
      confirmId: printer,
      confirmTitle:
        "Are you sure you want to delete printer #" +
        printer +
        " at host " +
        name +
        "?"
    });
  };

  handleChange = (e, { name, value }) => {
    let data = this.state.printers;
    if (name.indexOf("enabled") >= 0) {
      value = value === 1 ? "no" : "yes";
    }
    set(data, name, value);
    this.setState({ printers: data });
  };

  handleCancel = () => {
    this.setState({
      result: "cancelled",
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
  };

  handleConfirm = () => {
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    if (this.state.confirmId === "restart") {
      this.handleRestart();
    } else {
      this.handleDelete();
    }
  };

  handleSubmit = () => {
    this.setState({
      isLoading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    return request
      .post(this, "api:/drum-printer", {
        printers: this.state.printers
      })
      .then(resp => {        
        if (resp.error){
          this.setState({
            xhrStatus: resp.status,
            xhrMessage: resp.message,            
            isLoading: false
          });
        } else {
          this.fetchData();
        }
      });
  };

  handleDelete() {
    
    const { confirmId } = this.state;

    return request
    .delete(this, `api:/drum-printer/${confirmId}`)
    .then(resp => {
      this.setState({
        xhrStatus: resp.status,
        xhrMessage: resp.message,
        confirmOpen: false,
        confirmId: "",
        confirmTitle: ""
      });
      this.fetchData();
      return true;
    }).then(result => {
      setTimeout(() => {
        this.setState({
          confirmOpen: true,
          confirmId: "restart",
          confirmTitle: "Would you like to restart the print service now?"
        });
      }, 1000)
    });
  }

  handleRestart() {
    return request
    .post(this, "api:/drum-printer/restart", {})
    .then(resp => {
      this.setState({
        xhrStatus: resp.status,
        xhrMessage: resp.message,
        confirmOpen: false,
        confirmId: "",
        confirmTitle: ""
      });

      this.fetchData();
      return true;
    });
  }

  render() {
    const {
      isLoading,
      xhrStatus,
      xhrMessage,
      confirmOpen,
      confirmTitle,
      printers
    } = this.state;
    return (
      <Segment basic>
        <Confirm
          open={confirmOpen}
          content={confirmTitle}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Form
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onSubmit={this.handleSubmit}
        >
          <Message success content={xhrMessage} />
          <Message error content={xhrMessage} />

          {printers.map((value, index) => (
            <Form.Group key={index} inline>
              <Form.Input
                name={"" + index + ".host"}
                label={value.id === "0" ? "New" : "#" + value.id}
                placeholder="Printer host"
                value={value.host}
                width={4}
                onChange={this.handleChange}
                className="drumPrintersInput"
              />
              <Form.Input
                name={"" + index + ".port"}
                label={" "}
                placeholder="Printer host"
                value={value.port}
                width={2}
                onChange={this.handleChange}
                className="drumPrintersInput drumPrintersGroup"
              />
              <Form.Checkbox
                toggle
                name={`${index}.enabled`}
                label="Enabled"
                value={value.enabled === "yes" ? 1 : 0}
                defaultChecked={value.enabled === "yes" ? true : false}
                onChange={this.handleChange}
                className="radioToggleBtn drumPrintersInput"
              />
              {value.id > 0 && (
                <Form.Button
                  printer={value.id}
                  name={value.host}
                  secondary
                  type="button"
                  onClick={this.deletePrinter}
                  icon="trash"
                  className="drumPrintersInput"
                />
              )}
            </Form.Group>
          ))}
          <Form.Button primary>Submit</Form.Button>
          <Form.Button type="button" primary onClick={this.handleRestart}>Restart</Form.Button>
        </Form>
      </Segment>
    );
  }
}

export default PrinterTab;
